import { getSortedCalendars } from '@/services/connectedCalendars.service';
import IConnectedCalendar from '@/types/IConnectedCalendar';
import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Avatar, Flex, Text } from '@chakra-ui/react';
import Calendar from './components/Calendar';

interface IHostProps {
	avatar: string;
	calendars: IConnectedCalendar[];
	email: string;
	isLoading: boolean;
	showSecondaryCalendars: boolean;
	onChangeRead: (calendarId: string, value: boolean) => void;
	onChangeWrite: (calendarId: string, value: boolean) => void;
}

export default function Host(props: IHostProps) {
	// We don't want to show hosts with no connected calendars
	if (!props.calendars.length) {
		return null;
	}

	return (
		<AccordionItem>
			<AccordionButton background="gray.50" aria-label={props.email}>
				<Flex alignItems="center" flex="1">
					<Avatar name={props.email} size="xs" mr="2" src={props.avatar} />
					<Text>{props.email}</Text>
				</Flex>
				<AccordionIcon />
			</AccordionButton>

			<AccordionPanel p="0" pl="2" m="0">
				{getSortedCalendars(props.calendars)
					.filter((c) => c.primary || props.showSecondaryCalendars)
					.map((c, i) => (
						<Calendar
							{...c}
							isLoading={props.isLoading}
							isOpen={i === 0}
							isReadOnly={c.readOnly}
							key={c.id}
							onChangeRead={props.onChangeRead}
							onChangeWrite={props.onChangeWrite}
						/>
					))}
			</AccordionPanel>
		</AccordionItem>
	);
}
